import { forwardRef } from 'react';
import {
  StyledEmojiPickerTrigger,
  StyledArrowDownIcon,
  StyledEmojiIcon,
} from './styled';
import { useEmojiPickerContext } from '../../../contexts/emoji-picker';

const EmojiPickerTrigger = forwardRef((props, ref) => {
  const { triggerProps } = useEmojiPickerContext();

  return (
    <StyledEmojiPickerTrigger ref={ref} {...triggerProps(ref, props)}>
      <StyledEmojiIcon>{triggerProps().emoji}</StyledEmojiIcon>
      <StyledArrowDownIcon />
    </StyledEmojiPickerTrigger>
  );
});

export default EmojiPickerTrigger;
